<template>
  <div
    v-if="!dataLoad"
    class="filter-user-site"
  >
    <div class="filter-head">
      <div class="filter-title">
        <div class="filter-icon">
          <feather-icon
            icon="SlidersIcon"
            size="16"
            class="text-white"
          />
        </div>
        <div class="ml-1">
          <div class="filter-heading">
            Refine results
          </div>
          <div class="filter-subtitle">
            Choose office & role, then apply the filter to update the table.
          </div>
        </div>
      </div>
    </div>

    <b-row class="mt-1 filters-row">
      <b-col
        cols="12"
        md="3"
      >
        <div class="field-label">
          <feather-icon
            icon="MapPinIcon"
            size="14"
            class="mr-25 text-muted"
          />
          Office
        </div>
        <SelectOffice :show-select-office="true" />
      </b-col>

      <b-col
        cols="12"
        md="3"
      >
        <div class="field-label">
          <feather-icon
            icon="ShieldIcon"
            size="14"
            class="mr-25 text-muted"
          />
          Role
        </div>
        <SelectRoles :show-select-role="true" />
      </b-col>

      <b-col
        cols="12"
        md="3"
      >
        <div class="field-label">
          <feather-icon
            icon="CheckCircleIcon"
            size="14"
            class="mr-25 text-muted"
          />
          Apply
        </div>
        <b-button
          variant="primary"
          class="action-btn action-primary w-100"
          :disabled="isApplying"
          @click="applyFilters"
        >
          <b-spinner
            v-if="isApplying"
            small
            class="mr-50"
            label="Loading"
          />
          <feather-icon
            v-else
            icon="SearchIcon"
            size="16"
            class="mr-50"
          />
          Apply
        </b-button>
      </b-col>

      <b-col
        cols="12"
        md="3"
      >
        <div class="field-label">
          <feather-icon
            icon="RefreshCwIcon"
            size="14"
            class="mr-25 text-muted"
          />
          Reset
        </div>
        <b-button
          variant="outline-danger"
          class="action-btn w-100"
          @click="resetFilters"
        >
          <feather-icon
            icon="RefreshCwIcon"
            size="16"
            class="mr-50"
          />
          Reset
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SelectOffice from './fixed-filter/SelectOffice.vue'
import SelectRoles from './fixed-filter/SelectRoles.vue'

export default {
  name: 'FilterUserUserSite',
  components: {
    SelectRoles,
    SelectOffice,
  },
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
  data() {
    return {
      isApplying: false,
    }
  },
  methods: {
    async applyFilters() {
      try {
        if (this.isApplying) return
        this.isApplying = true
        await this.getAllData(1)
      } finally {
        this.isApplying = false
      }
    },
    resetFilters() {
      const next = { ...this.$route.query }
      delete next.office
      delete next.role
      delete next.search
      this.$router.replace({ query: next })
      this.getAllData(1)
    },
  },
}
</script>
